const SERVICE_TYPES = {
  CHECKIN           : 'checkin',
  CITY_DELIVERY     : 'cityDelivery',
  TRANSFER          : 'transfer',
  SKIP_BAGGAGE_CLAIM: 'skipBaggageClaim',
  STORAGE           : 'storage',
  LOST_AND_FOUND    : 'lostAndFound',
  TRAVEL_D2D        : 'travelD2D',
  DELIVERY_D2D      : 'deliveryD2D',
} as const;

export type ServiceTypes = typeof SERVICE_TYPES;

export const SERVICE_TYPES_ORIGIN = [
  SERVICE_TYPES.CHECKIN,
  SERVICE_TYPES.TRANSFER,
];

export const SERVICE_TYPES_DESTINATION = [
  SERVICE_TYPES.SKIP_BAGGAGE_CLAIM,
  SERVICE_TYPES.CITY_DELIVERY,
];

export const SERVICE_TYPES_REGULATED = [
  SERVICE_TYPES.CHECKIN,
  SERVICE_TYPES.SKIP_BAGGAGE_CLAIM,
  SERVICE_TYPES.TRAVEL_D2D,
];

export const SERVICE_TYPES_DELIVERY = [
  SERVICE_TYPES.DELIVERY_D2D,
]

export const SERVICE_TYPES_TRANSFER = [
  SERVICE_TYPES.TRANSFER,
  SERVICE_TYPES.CITY_DELIVERY,
];

export const SERVICE_TYPES_LOST_AND_FOUND = [
  SERVICE_TYPES.LOST_AND_FOUND,
];

export type DeliveryServiceTypes = typeof SERVICE_TYPES_DELIVERY[number];
export type RegulatedServiceTypes = typeof SERVICE_TYPES_REGULATED[number];

export default SERVICE_TYPES;
